import {
  SET_DATA_SEARCH_FILTER,
  GET_DATA_SEARCH,
  SET_VISIBLE_MODAL_ADV,
} from "../constants";
import { SearchAdvanceBang } from "../../services/search";
import { message } from "antd";
import Cookies from "js-cookie";

export const setValueFilter = (payload) => async (dispatch) => {
  dispatch({
    type: SET_DATA_SEARCH_FILTER,
    payload,
  });
};

export const setValueVisibleFilter = (payload) => async (dispatch) => {
  dispatch({
    type: SET_VISIBLE_MODAL_ADV,
    payload,
  });
};

export const searchBangAdv = (payload) => async (dispatch) => {
  let params = {
    ...payload.params,
    idtruong: payload.params.idtruong?.value,
  }
  try {
    const res = await SearchAdvanceBang(params);
    if (res) {
      const { data } = res.data;
      dispatch({
        type: GET_DATA_SEARCH,
        payload: data,
      });
      return data;
    }
  } catch (error) {
    if (error.response.data === "Cookie hết hạn") {
      Cookies.remove("code");
      payload.callback();
      return null;
    }
    message.error("Có lỗi xảy ra, vui lòng thử lại!");
  }
};
